/* @flow */
import { Map, List, merge } from 'immutable';
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { PHISHING_SCORE_VALUES, TRIAGE_STATUS_OPTIONS } from 'trustar-2.0/hooks/constants';
import DATE_CONSTANTS from 'trustar-2.0/utils/Date.constants';
import { metadataCache } from 'modules/reports/getters';

export const isSetTriageStatusInProgress = getterFromKeyPath(['triage', 'isSetTriageStatusInProgress']);
export const isFetchTriageReportsInProgress = getterFromKeyPath(['triage', 'isFetchTriageReportsInProgress']);

export const triageSubmissions = getterFromKeyPath(['triage', 'triageSubmissions']);
export const currentTriageQuery = getterFromKeyPath(['triage', 'currentTriageQuery']);

export const getLoadingMessage = getterFromKeyPath(['triage', 'loadingMessage']);

// Default Payloads
export const defaultTriageRequestPayload = Map({
  from: Date.parse(DATE_CONSTANTS.YESTERDAY.toString()),
  to: Date.now(),
  enclaveIds: List([]),
  priorityEventScore: List(TRIAGE_STATUS_OPTIONS),
  normalizedIndicatorScore: List(TRIAGE_STATUS_OPTIONS),
  status: List([PHISHING_SCORE_VALUES.UNRESOLVED]),
});

export const initialTriageSubmissionsState = Map({
  items: List(),
  responseMetadata: Map({
    nextCursor: '',
    totalItems: 0,
  })
});

export const getTriageReportsWithMetadata = createSelector(
  [triageSubmissions, metadataCache],
  (triageReports, metadata) => triageReports.update('items', (reports) => (
    reports.filter((report) => metadata.get(report.get('submissionId')))
  )),
);

/* Merge reports search results with reports metadata and summary data */
export const enrichedTriageReports = createSelector(
  [triageSubmissions, metadataCache, isFetchTriageReportsInProgress],
  (triageReports, metadata, isFetchTriageReportsInProgress) => (
    triageReports.update('items', (reports) => reports.map((report) => {
      const reportGuid = report.get('submissionId');
      const title = report.get('title');
      const reportMetadata = metadata.get(reportGuid, Map());

      // Used to show logos. This map's shape is derived from the summary endpoint source information
      // for interchangability between payloads.
      const sourceKeyAndName = Map({
        source: Map({
          key: report.get('sourceKey'),
          name: report.get('sourceName'),
        }),
      });

      return {
        reportGuid,
        sourceKeyAndName,
        reportMetadata: merge(reportMetadata, Map({ title })),
        context: report.get('context', List()),
        priorityEventScore: report.get('priorityEventScore', -1),
        reportMetadataLoading: isFetchTriageReportsInProgress,
        scoreCount: report.get('scoreCount', List()),
      };
    }))
));



// WEBPACK FOOTER //
// ./src/app/modules/triage/getters.js